export const DATE_DOWN = 'Date décroissante'
export const DATE_UP = 'Date croissante'
export const PRICE_DOWN = 'Prix décroissant'
export const PRICE_UP = 'Prix croissant'
export const DOWN = 'down'
export const UP = 'up'
export const LOCATION_FILTER = "Lieu"
export const TYPES_FILTER  = "Type(s) de bien(s)"
export const SURFACE_FILTER = "Surface Min" 
export const BUDGET_FILTER  = "Budget Max"
export const ROOMS_FILTER  = "Nombre de pièces"
export const TYPE = ["Appartement", "Maison", "Parking"]

export const SORT_VALUES = [
    DATE_DOWN,
    DATE_UP,
    PRICE_DOWN,
    PRICE_UP,
]
